var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.limitNum)?_c('p',{staticClass:"limit_time"},[_vm._v("[限时订单]")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }